import RelativePerformance from './RelativePerformance';

export default RelativePerformance;
